import React from "react";

const CustomDatePicker = React.forwardRef(({ value, onClick }, ref) => (
  <button data-testid="common-customdatepicker-button-1"
    className="btn btn-outline-secondary btn-sm"
    onClick={(e) => {
      e.preventDefault();
      onClick();
    }}
  >
    <span className="fa fa-calendar-alt"></span>&nbsp;
    {value}
  </button>
));

export default CustomDatePicker;
